import React from "react";
import PropTypes from "prop-types";
import MslDesktop from "./MslDesktop";

function Msl({ app, config }) {

  return  <MslDesktop app={app} config={config} />
}

Msl.defaultProps = {
	app: null,
	config: {},
};

Msl.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default Msl;
